var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"srcset":`${_vm.getImgUrl} 1x,${_vm.getImgUrl2x} 2x,${_vm.getImgUrl3x} 3x`,"src":_vm.getImgUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }